import { wrapCreateBrowserRouter } from '@sentry/react';
import { createBrowserRouter, RouteObject } from 'react-router';
import { Route } from '@/core/types';
import { AccessGranted } from '@/features/auth/hooks/useAuthorization';
import { ReactNode } from 'react';
import { getChildRoutes } from '@/core/pages/utils/getChildRoutes';
import globalRoutes from '@/core/pages/Routers/globalRouterConfig';
import ErrorPage from '@/core/components/ErrorHandlers/ErrorPage';

const sentryCreateBrowserRouter = wrapCreateBrowserRouter(createBrowserRouter);

export const createRouter = ({
  routes,
  wildcardElement,
  isAccessGranted,
}: {
  routes?: Route[]; // optional because we have global routes
  wildcardElement: ReactNode;
  isAccessGranted: AccessGranted;
}) => {
  const routerRoutes: RouteObject[] = getChildRoutes(
    [...globalRoutes, ...(routes ?? [])],
    isAccessGranted,
  );

  routerRoutes.push({
    path: '*',
    element: wildcardElement,
    errorElement: <ErrorPage />,
  });

  return sentryCreateBrowserRouter(routerRoutes, {
    basename: import.meta.env.VITE_PUBLIC_URL?.length ? import.meta.env.VITE_PUBLIC_URL : undefined,
  });
};
